import React, { Component } from 'react';
import TarjetasTable from './TarjetasTable';
import TablaSolicitudesPendientes from './TablaSolicitudesPendientes';
import DetalleCuenta from './DetalleCuenta/DetalleCuenta';

const Listado = ({ data, cambiarPantalla, eliminarSolicitud, plasticos, deleteSolicitudPendiente, mostrarAlertaProcesoFinalizado }) => {
    return (
        <div>

            <div>
                <TablaSolicitudesPendientes solicitudes={plasticos.solicitudes} deleteSolicitudPendiente={deleteSolicitudPendiente} data={data} plasticos={plasticos} />
            </div>

            <div>
                <TarjetasTable data={data} cambiarPantalla={cambiarPantalla} eliminarSolicitud={eliminarSolicitud} plasticos={plasticos} />
            </div>

        </div>
    );
}

class PantallaCuentas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pantalla: 'listado',
            cuentaSeleccionada: null,
            tarjetaSeleccionada: null
        };
    }

    cambiarPantalla(pantalla, cuenta, tarjeta) {
        this.setState({
            pantalla: pantalla,
            cuentaSeleccionada: cuenta,
            tarjetaSeleccionada: tarjeta
        });

    }

    render() {
        const { pantalla } = this.state;

        switch (pantalla) {
            case 'listado':
                return (
                    <Listado
                        plasticos={this.props.plasticos}
                        data={this.props.data}
                        cambiarPantalla={this.cambiarPantalla.bind(this)}
                        eliminarSolicitud={this.props.eliminarSolicitud}
                        deleteSolicitudPendiente={this.props.deleteSolicitudPendiente}
                    />
                );

            case 'detalleCuenta':
            case 'detalleApoderado':
                return (
                    <DetalleCuenta
                        plasticos={this.props.plasticos}
                        cuenta={this.state.cuentaSeleccionada}
                        tarjeta={this.state.tarjetaSeleccionada}
                        data={this.props.data}
                        cambiarPantalla={this.cambiarPantalla.bind(this)}
                        pantalla={pantalla}
                        getExisteSolicitudCuenta={this.props.getExisteSolicitudCuenta}
                        state={this.props.state}
                        borrarTarjeta={this.props.borrarTarjeta}
                        reimprimirTarjeta={this.props.reimprimirTarjeta}
                        reimprimirPin={this.props.reimprimirPin}
                        modificarSolicitud={this.props.modificarSolicitud}
                        mostrarAlertaProcesoFinalizado={this.props.mostrarAlertaProcesoFinalizado}
                        agregarQuitarCuentaVinculo={this.props.agregarQuitarCuentaVinculo}
                        grabarVinculacion={this.props.grabarVinculacion}
                        cambiarCuentaPrincipal={this.props.cambiarCuentaPrincipal}
                        GetVinculosByNroTarjeta={this.props.GetVinculosByNroTarjeta}
                        mostrarVinculos={this.props.mostrarVinculos}
                        getHistorialMovimiento={this.props.getHistorialMovimiento}
                        crearModificarSolicitudTarjeta={this.props.crearModificarSolicitudTarjeta}
                        getSolicitudesTarjetaByTarjetaId={this.props.getSolicitudesTarjetaByTarjetaId}
                        UserId={this.props.UserId}
                        getVinculaciones={this.props.getVinculaciones}
                        borrarVinculo={this.props.borrarVinculo}
                        mostrarOcultarModalVinculos={this.props.mostrarOcultarModalVinculos}
                    />
                );

            default:
                return null;
        }
    }

}

export default PantallaCuentas;
